// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Video-module--video-wrapper--3qn-r","noAccess":"Video-module--no-access--1DK6n","iframe":"Video-module--iframe--3eaIT","title":"Video-module--title--35UMo"};